<template>
  <div class="root" :style="scssProps">
    <img
      class="avatar"
      :src="src"
      :alt="name"
      @load="handleLoad"
      @error="handleError"
    >

    <div v-if="!imageLoaded" class="initials">
      {{ initials }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    name: { type: String, required: false, default: 'avatar' },
    src: { type: String, required: false, default: '/error' },
    size: { type: String, required: false, default: '32px' }
  },
  data: () => ({
    imageLoaded: false
  }),
  computed: {
    scssProps() {
      return {
        '--avatar-default-size': '32px',
        '--avatar-size': this.size,
        '--avatar-loaded-display': this.imageLoaded ? 'block' : 'none'
      }
    },
    initials() {
      return this.name
        .split(' ')
        .map(word => word[0])
        .slice(0, 2)
        .join('')
        .toUpperCase()
    }
  },
  methods: {
    handleLoad() {
      this.imageLoaded = true
    },
    handleError() {
      this.imageLoaded = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/variables';

.root {
  background-origin: #fff;
  border-radius: 50%;
  box-lines: border-box;
  display: inline-block;

  height: var(--avatar-size);
  width: var(--avatar-size);

  .avatar {
    border-radius: 50%;
    box-sizing: border-box;
    display: var(--avatar-loaded-display);
    height: var(--avatar-size);
    width: var(--avatar-size);
    object-fit: cover;
  }

  .initials {
    @include ParagraphSmall;
    font-family: $monserratFontFamily;
    color: $neutral400;

    background-color: $neutral300;
    align-items: center;
    display: flex;
    justify-content: center;
    height: 100%;
    border-radius: 50%;
  }
}
</style>
